<template>
  <RouterLink :to="linkRoute" class="card-article__item">
    <section class="card-article__type">
      <template v-if="tag">
        <span class="tag -float -small">
          <SvgIcon :id="icon" />
          {{ tag }}
        </span>
      </template>
    </section>

    <div class="card-article__figure" :style="{ backgroundImage: `url('/images/brand/placeholder.png')` }">
      <figure class="card-article__image" :style="{ backgroundImage: `url('${image}')` }" />
    </div>

    <section class="card-article__content -global">
      <div v-if="entry.isPublication || entry.isEvent" class="card-article__uptitle">
        <div class="card-article__data">
          <SvgIcon id="content-date" />
          <p>{{ formattedDate || 'Aucune date' }}</p>
        </div>

        <div v-if="readingTime" class="card-article__data">
          <SvgIcon id="time" />
          <p>{{ readingTime }} min</p>
        </div>
      </div>

      <h4 class="card-article__title">
        {{ title }}
      </h4>
    </section>
  </RouterLink>
</template>

<script>
import moment from 'moment'
import { getReadingTime } from '@/helpers/content-formatting'
import { typeTagMap, typeIconMap, eventTypeTagMap, eventTypeIconMap } from '@/helpers/type-maps'

export default {
  name: 'MultiCard',
  props: {
    entry: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      typeTagMap,
      typeIconMap
    }
  },
  computed: {
    type() {
      return this.entry.type || 'publication'
    },
    title() {
      if (this.entry.slug === 'home') return 'Accueil'
      return this.entry.shortTitle || this.entry.title
    },
    tag() {
      if (this.entry.isEvent) return eventTypeTagMap[this.entry.eventType || 'event'] || null
      return this.typeTagMap[this.type] || null
    },
    icon() {
      if (this.entry.isEvent) return eventTypeIconMap[this.entry.eventType || 'event'] || null
      return this.typeIconMap[this.type] || null
    },
    image() {
      if (this.entry.featuredImage) return this.entry.featuredImage

      if (this.entry.isPage || this.entry.isProject) {
        return this.entry.slug === 'home' ? '/images/home-1.jpg' : this.entry.intro && this.entry.intro.image
      }

      if (!this.entry.images || !this.entry.images.length) return '/images/brand/placeholder.png'

      const [image1, image2 = null] = this.entry.images
      return image1 || image2
    },
    formattedDate() {
      if (this.entry.isEvent) {
        return this.entry && this.entry.date ? moment(this.entry.date).format('D MMMM YYYY') : null
      }

      return this.entry && this.entry.original_publish_date
        ? moment(this.entry.original_publish_date).format('D MMMM YYYY')
        : null
    },
    readingTime() {
      return this.entry && this.entry.isPublication && getReadingTime(this.entry.content)
    },
    linkRoute() {
      if (this.entry.isPage) return { name: this.entry.slug }

      if (this.entry.type === 'monitoring') {
        return { name: 'resources-monitoring-single', params: { monitoringSlug: this.entry.slug } }
      }

      if (this.entry.isProject) {
        return { name: 'project-single', params: { projectSlug: this.entry.slug } }
      }

      const publicationName = this.entry.isPublication ? 'publication-single' : 'news-single'
      const routeName = this.entry.isEvent ? 'event-single' : publicationName
      const publicationSlugKey = this.entry.isPublication ? 'publicationSlug' : 'newsSlug'
      const slugKey = this.entry.isEvent ? 'eventSlug' : publicationSlugKey

      return { name: routeName, params: { [slugKey]: this.entry.slug } }
    }
  },
  mounted() {
    if (!this.tag) console.log(this.entry)
  }
}
</script>
